import React from 'react'
import FadeInOnScroll from './FadeInOnScroll'

const WaterfallFadeIn = ({ 
  children, 
  baseDelay = 0.1, 
  duration = 0.6,
  direction = 'up',
  distance = 50,
  className = '',
  triggerOnce = false
}) => {
  // Convert children to array if it's not already
  const childrenArray = React.Children.toArray(children)

  return (
    <div className={className}>
      {childrenArray.map((child, index) => (
        <FadeInOnScroll
          key={index}
          duration={duration}
          delay={baseDelay * index}
          direction={direction}
          distance={distance}
          triggerOnce={triggerOnce}
        >
          {child}
        </FadeInOnScroll>
      ))}
    </div>
  )
}

export default WaterfallFadeIn 